document.addEventListener('click',event=>{const opener=event.target.closest('.he-menu-open');if(opener){const dialog=document.getElementById(opener.getAttribute('aria-controls'));if(dialog&&!dialog.open)dialog.showModal();}const dialog=event.target.closest('.he-menu');if(dialog&&event.target===dialog){const rect=dialog.getBoundingClientRect();if(event.clientX<rect.left||event.clientX>rect.right||event.clientY<rect.top||event.clientY>rect.bottom)dialog.close();}});
document.addEventListener('shopify:section:unload',()=>{const dialog=document.querySelector('.he-menu[open]');if(dialog)dialog.close();});

document.addEventListener('keydown',event=>{const button=event.target.closest('add-to-cart[role="button"],quick-view-button[role="button"]');if(button&&(event.key==='Enter'||event.key===' ')){event.preventDefault();if(!button.hasAttribute('disabled'))button.click();}});
document.addEventListener('click',event=>{const button=event.target.closest('add-to-cart');if(button&&button.hasAttribute('disabled')){event.preventDefault();event.stopImmediatePropagation();}},true);
document.addEventListener('ajaxProduct:added',()=>{const status=document.getElementById('he-cart-status');if(status)status.textContent=status.dataset.added;});
document.addEventListener('ajaxProduct:error',event=>{const status=document.getElementById('he-cart-status');if(status)status.textContent=event.detail.errorMessage;});

document.addEventListener('click',event=>{
  document.querySelectorAll('.he-nav-dropdown[open]').forEach(menu=>{
    if(!menu.contains(event.target))menu.open=false;
  });
});
document.addEventListener('toggle',event=>{
  if(!event.target.matches('.he-nav-dropdown[open]'))return;
  document.querySelectorAll('.he-nav-dropdown[open]').forEach(menu=>{
    if(menu!==event.target)menu.open=false;
  });
},true);
document.addEventListener('keydown',event=>{
  if(event.key!=='Escape')return;
  const menu=event.target.closest('.he-nav-dropdown[open]');
  if(menu){menu.open=false;menu.querySelector('summary').focus();event.preventDefault();}
});
